module.exports = __webpack_public_path__ + "img/nc.5b7abd52.svg";